import React from 'react';
import { Button } from '@medely/ui-kit';
import useDialog from '@mp/hooks/useDialog';
import { ReleaseShiftModal } from './releaseShiftModal';
import { ReleaseShiftOptionsProps } from './releaseShiftModal/interface';
import { DROP_OPTION, RELEASE_OPTION, SWAP_OPTION } from './constants';
import { isShiftWindowOpen } from './shiftReleaseUtils';
import { useShiftRelease } from './useShiftRelease';

type ReleaseShiftButtonProps = {
  jobId?: number | null;
  locationId?: number | null;
};

export const ReleaseShiftButton = ({ jobId, locationId }: ReleaseShiftButtonProps) => {
  const { closeDialog, open, openDialog } = useDialog();
  const {
    allowDropWindow,
    allowReleaseWindow,
    allowSwapWindow,
    canBeRelease,
    canBeDrop,
    canBeSwap,
    startTime,
  } = useShiftRelease({ jobId: jobId as number });

  const isReleaseWindowOpen = isShiftWindowOpen({
    shiftWindow: allowReleaseWindow,
    startTime,
  });
  const isDropWindowOpen = isShiftWindowOpen({
    shiftWindow: allowDropWindow,
    startTime,
  });
  const isSwapWindowOpen = isShiftWindowOpen({
    shiftWindow: allowSwapWindow,
    startTime,
  });

  const canReleaseFinal = canBeRelease && isReleaseWindowOpen;
  const canDropFinal = canBeDrop && isDropWindowOpen;
  const canSwapFinal = canBeSwap && isSwapWindowOpen;

  const isDisabled = !canDropFinal && !canSwapFinal && !canReleaseFinal;

  const options = [
    ...(canReleaseFinal ? [RELEASE_OPTION] : []),
    ...(canSwapFinal ? [SWAP_OPTION] : []),
    ...(canDropFinal ? [DROP_OPTION] : []),
  ] as ReleaseShiftOptionsProps[];

  return (
    <>
      <Button variant="outlined" onClick={openDialog} disabled={isDisabled} fullWidth>
        Release shift
      </Button>
      <ReleaseShiftModal
        open={open}
        onClose={closeDialog}
        jobId={jobId}
        releaseOptions={options}
        locationId={locationId}
      />
    </>
  );
};
